<template>
  <div class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50" @click.self="$emit('close')">
    <div class="bg-white rounded-lg shadow-xl p-6 w-full max-w-md">
      <h3 class="text-lg font-semibold mb-4">Импорт номенклатуры из Excel</h3>

      <div class="mb-4 p-3 rounded bg-gray-50 text-sm text-gray-700">
        <p class="font-medium mb-1">Формат файла</p>
        <ul class="list-disc pl-4 space-y-0.5">
          <li>Колонка B — Номенклатура, C — Артикул, D — Группа (как в 1С).</li>
          <li>Строки 1 и 2 — шапка, позиции начинаются с 3-й строки.</li>
          <li>Загружается лист, который был открыт при сохранении файла.</li>
          <li>Единица измерения: для группы «УСЛУГИ ОКАЗЫВАЕМЫЕ» — «услуга», для остальных — «шт».</li>
          <li>Позиции, у которых уже есть такой артикул или наименование, пропускаются.</li>
        </ul>
      </div>

      <div
        class="border-2 border-dashed rounded-lg p-8 text-center mb-4 transition-colors"
        :class="isDragOver ? 'border-blue-500 bg-blue-50' : 'border-gray-300'"
        @dragover.prevent="isDragOver = true"
        @dragleave="isDragOver = false"
        @drop.prevent="handleDrop"
      >
        <p v-if="!selectedFile" class="text-gray-500">
          Перетащите файл .xls/.xlsx сюда или
          <label class="text-blue-600 cursor-pointer hover:underline">
            выберите
            <input type="file" accept=".xls,.xlsx" class="hidden" @change="handleFileSelect" />
          </label>
        </p>
        <p v-else class="text-gray-700 font-medium" style="word-break: break-word; overflow-wrap: anywhere;">{{ selectedFile.name }}</p>
      </div>

      <div v-if="result" class="mb-4 p-3 rounded text-sm" :class="result.success ? 'bg-green-50 text-green-800' : 'bg-red-50 text-red-800'">
        <template v-if="result.success">
          <table class="w-full text-left">
            <tbody>
              <tr>
                <td class="py-0.5">Создано позиций:</td>
                <td class="py-0.5 font-medium text-right">{{ result.created }}</td>
              </tr>
              <tr>
                <td class="py-0.5">Уже были в номенклатуре:</td>
                <td class="py-0.5 font-medium text-right">{{ result.existing }}</td>
              </tr>
              <tr v-if="result.errors.length">
                <td class="py-0.5 text-red-700">Не загружено:</td>
                <td class="py-0.5 font-medium text-right text-red-700">{{ result.errors.length }}</td>
              </tr>
            </tbody>
          </table>
          <ul v-if="result.errors.length" class="mt-2 text-red-700 text-xs list-disc pl-4">
            <li v-for="error in result.errors" :key="error">{{ error }}</li>
          </ul>
        </template>
        <p v-else>{{ result.message }}</p>
      </div>

      <div class="flex justify-end space-x-2">
        <button
          @click="$emit('close')"
          class="px-4 py-2 border border-gray-300 rounded hover:bg-gray-50 text-sm"
        >
          {{ result?.success ? 'Закрыть' : 'Отмена' }}
        </button>
        <button
          v-if="!result?.success"
          @click="upload"
          :disabled="!selectedFile || loading"
          class="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700 text-sm disabled:opacity-50"
        >
          {{ loading ? 'Загрузка...' : 'Импортировать' }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  emits: ['close', 'imported'],
  data() {
    return {
      selectedFile: null,
      isDragOver: false,
      loading: false,
      result: null,
    };
  },
  methods: {
    handleFileSelect(e) {
      this.selectedFile = e.target.files[0] || null;
      this.result = null;
    },
    handleDrop(e) {
      this.isDragOver = false;
      const file = e.dataTransfer.files[0];
      if (file && /\.(xls|xlsx)$/i.test(file.name)) {
        this.selectedFile = file;
        this.result = null;
      }
    },
    async upload() {
      if (!this.selectedFile || this.loading) return;

      this.loading = true;
      this.result = null;

      const formData = new FormData();
      formData.append('file', this.selectedFile);

      try {
        const { data } = await axios.post('/api/product/importProducts', formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });
        this.result = {
          success: true,
          created: data.data.created,
          existing: data.data.existing,
          errors: data.data.errors || [],
        };
        this.$emit('imported');
      } catch (err) {
        console.error('Ошибка импорта номенклатуры:', err);
        this.result = {
          success: false,
          message: err.response?.data?.message || 'Не удалось загрузить файл, попробуйте ещё раз',
        };
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
